<div>
  <app-header
    styleClass="text-lg"
    icon="fas fa-wand-magic-sparkles"
    text="Schnellauswahl"></app-header>

  <div class="presets-grid">
    <button
      *ngFor="let preset of presets"
      pButton
      type="button"
      class="p-3 relative"
      [raised]="true"
      [text]="true"
      [class.active]="isActive(preset)"
      (click)="selectPreset(preset)">
      <div class="flex align-items-start gap-3">
        <div class="preset-icon flex-shrink-0">
          <i [class]="preset.icon"></i>
        </div>
        <div class="flex flex-column gap-1 text-left">
          <div class="font-bold">{{ preset.label }}</div>
          <div class="text-sm text-color-secondary">
            {{ preset.description }}
          </div>
        </div>
      </div>
      @if (isActive(preset)) {
        <i
          class="fas fa-check-circle absolute top-0 right-0 m-2 text-primary"></i>
      } @else {
        <i
          class="fa-regular fa-circle absolute top-0 right-0 m-2 text-color-secondary"></i>
      }
    </button>

    <div class="p-3 bg-blue-50 border-round border-1 border-blue-200 text-sm">
      <i class="fas fa-info-circle text-blue-600 mr-2"></i>
      <span class="text-blue-800">
        <strong>Tipp:</strong> Nutzen Sie die Schnellauswahl für häufige
        Vergleichsarten. Die manuelle Anpassung bietet erweiterte Kontrolle.
      </span>
    </div>
  </div>
</div>
